import type { UserProfile } from '@pharmaconnect/types'
import { Navigate, Outlet } from 'react-router-dom'

import { useAuthStore } from '../stores/authStore'

interface RoleGuardProps {
  /** Rôles autorisés. Tout autre profil est redirigé. */
  allow: ReadonlyArray<UserProfile['role']>
  /** Cible du redirect quand le rôle n'est pas autorisé. Par défaut '/'. */
  fallback?: string
}

export function RoleGuard({ allow, fallback = '/' }: RoleGuardProps) {
  const profile = useAuthStore((s) => s.profile)
  if (!profile) return null
  if (!allow.includes(profile.role)) return <Navigate to={fallback} replace />
  return <Outlet />
}

/**
 * Redirect home — chaque rôle a sa landing page.
 * Caissier → /caisse, Médecin → /mes-patients, Super_admin → /admin (V81),
 * Owner/Manager → DashboardPage (V76 : super_admin a son propre dashboard +
 * V81 : landing dédié /admin distinct de la liste pharmacies /admin/pharmacies).
 */
export function HomeRedirect({ children }: { children: React.ReactNode }) {
  const profile = useAuthStore((s) => s.profile)
  if (!profile) return null
  if (profile.role === 'cashier') return <Navigate to="/caisse" replace />
  if (profile.role === 'doctor') return <Navigate to="/mes-patients" replace />
  if (profile.role === 'super_admin') return <Navigate to="/admin" replace />
  return <>{children}</>
}
